import { Pipe, PipeTransform } from '@angular/core';
import { SearchCondition } from '../model/search-condition.model';
import { StringService } from '../service/string.service';

@Pipe({
  name: 'highlightSearchedKeyword'
})
export class HighlightSearchedKeywordPipe implements PipeTransform {

  constructor( private stringService: StringService ) {}

  transform(value: string, searchParams: SearchCondition, matchedSkills: string[]): string {
    if (searchParams && value) {
      // テキスト検索時のキーワードでハイライトする
      const plusKeyWords = this.getPlusKeyWords(searchParams.keyword);
      if (matchedSkills) {
        matchedSkills.forEach(skill => plusKeyWords.push(skill))
      }
      plusKeyWords.forEach(keyword => {
        const zenkakuKeyword = this.stringService.hankakuToZenkaku(keyword);
        const regrex = new RegExp(
          `(?![^<]*>)${this.stringService.escapeSpecialChar(keyword)}|(?![^<]*>)${this.stringService.escapeSpecialChar(zenkakuKeyword)}`
            ,
          'gi'
        );
        value = value.replace(regrex, `<span class="highlight">$&</span>`);
      });
    }
    return value;
  }

  private getPlusKeyWords(searchWord: string): Array<string> {
    let plusKeyWords = [];
    if (searchWord) {
      const keywords = searchWord.split(new RegExp('[\x20\u3000]'));
      plusKeyWords = keywords.filter(
        keyword => keyword[0] !== '-' && keyword !== ''
      );
    }
    return plusKeyWords;
  }
}
